<template>
  <PlaceModal
    :value="isDialogOpened"
    @input="handleCloseModal"
  >
    <template #footer>
      <BtnShowDoctors
        :active="isDialogOpened"
        class="pa-2 elevation-8"
        @click:submit="applySelectedPlace"
        @click:close="closeDialog"
      />
    </template>
  </PlaceModal>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import getPlaceLabel from 'www/vue_components/common/TheFilters/doctors/components/PlaceFilters/functions/getPlaceLabel'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import replaceMetaRobots from 'www/vue_components/common/TheFilters/doctors/functions/replaceMetaRobots'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import PlaceModal from 'www/vue_components/common/TheFilters/doctors/components/PlaceFilters/components/PlaceModal.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()

const { isDialogOpened, openDialog, closeDialog } = useDialogManager('PlaceFilters')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

watch(
  () => filtersStore.filters.place,
  () => {
    const name = getPlaceLabel({ place: filtersStore.filters.place, isChip: true })

    chipsStore.updatePlaceChip({
      name,
      isActive: !!filtersStore.filters.place,
      dropdown: !filtersStore.filters.place,
      truncate: true,
      isVisible: !!name,
      onClick: openDialog,
      onReset: async () => {
        filtersStore.updateFilters({ place: undefined })

        replaceMetaRobots()
        await updateDoctorListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

function applySelectedPlace() {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  replaceMetaRobots()
  updateDoctorListPage()
}

function handleCloseModal() {
  closeDialog()
  filtersStore.resetUnsavedFilters()
}
</script>
